import * as yup from 'yup';
import { TFunction } from 'i18next';
import {
  ContractResponseDto,
  ContractResponseDtoNtuReasonEnum,
} from 'libs/pinnacle-sdk';
import { isNil } from 'lodash';

export interface ClosingReasonFormValues {
  competitorRateOnExposure?: number;
  closingReason?: string;
  competitorRateOnLine?: number;
  ntuReason?: ContractResponseDtoNtuReasonEnum;
}

export const getInitialClosingReason = (
  contract?: ContractResponseDto
): ClosingReasonFormValues => {
  return {
    competitorRateOnExposure: isNil(contract?.competitorRateOnExposure)
      ? undefined
      : Number(contract?.competitorRateOnExposure),
    closingReason: contract?.closingReason,
    competitorRateOnLine: isNil(contract?.competitorRateOnLine)
      ? undefined
      : Number(contract?.competitorRateOnLine),
    ntuReason: contract?.ntuReason,
  };
};

export const getClosingReasonValidationSchemaShape = (t: TFunction) => ({
  competitorRateOnExposure: yup
    .number()
    .nullable()
    .min(
      0,
      t('validation.min', {
        field: t('contractDetail.competitorRateOnExposure'),
        min: 0,
      })
    ),
  closingReason: yup.string(),
  competitorRateOnLine: yup
    .number()
    .nullable()
    .min(
      0,
      t('validation.min', {
        field: t('contractDetail.competitorRateOnLine'),
        min: 0,
      })
    ),
  ntuReason: yup.string(),
});
